<div class="modal-header bg-primary text-white py-2">
  <h6 class="modal-title mb-0"><i class="fas fa-credit-card me-2"></i>Agregar pago</h6>
  <button type="button" class="btn btn-sm btn-outline-light" (click)="cancelar()">&times;</button>
</div>
<div class="modal-body">
  <div class="card">
    <div class="card-header p-0">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#cheque" type="button" role="tab">
            <i class="fas fa-money-check me-1"></i>Cheque
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" data-bs-toggle="tab" data-bs-target="#transferencia" type="button" role="tab">
            <i class="fas fa-exchange-alt me-1"></i>Transferencia Bancaria
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tarjeta" type="button" role="tab">
            <i class="fas fa-credit-card me-1"></i>Tarjeta crédito/débito
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" data-bs-toggle="tab" data-bs-target="#efectivo" type="button" role="tab">
            <i class="fas fa-hand-holding-usd me-1"></i>Fondo en efectivo
          </button>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <div class="tab-content">
        <!-- Cheque -->
        <div class="tab-pane fade show active" id="cheque" role="tabpanel">
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">Fecha de vencimiento</label>
                <input [(ngModel)]="nuevoCheque.dueDate" type="date" class="form-control">
              </div>
              <div class="mb-3">
                <label class="form-label">Banco</label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text bg-light"><i class="fas fa-university"></i></span>
                  <select [(ngModel)]="nuevoCheque.bankTransfer" class="form-select">
                    <option [ngValue]="''">Seleccione banco</option>
                    <option *ngFor="let b of bancosCheques" [ngValue]="b.BankCode">{{ b.BankName }}</option>
                  </select>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label d-flex justify-content-between align-items-center">
                  <span>Cuenta de mayor</span>
                  <small class="text-muted ms-2">{{ chequeCuentaName }}</small>
                </label>
                <div class="input-group input-group-sm">
                  <input [ngModel]="chequeCuentaLabel" class="form-control" readonly>
                  <button type="button" class="btn btn-warning"><i class="fas fa-arrow-right"></i></button>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">N° de cheque</label>
                <input [(ngModel)]="nuevoCheque.checkNum" type="text" class="form-control">
              </div>
              <div class="mb-3">
                <label class="form-label">Endosado</label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text bg-light"><i class="fas fa-file-signature"></i></span>
                  <select [(ngModel)]="nuevoCheque.endosado" class="form-select">
                    <option [ngValue]="'SI'">Sí</option>
                    <option [ngValue]="'NO'">No</option>
                  </select>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label">Importe</label>
                <input [(ngModel)]="nuevoCheque.ammount" type="number" class="form-control" placeholder="0">
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-start mt-2">
            <button type="button" class="btn btn-primary btn-sm" (click)="agregarChequeDesdeUI()"><i class="fas fa-plus me-1"></i>Agregar</button>
          </div>
        </div>
        <!-- Transferencia -->
        <div class="tab-pane fade" id="transferencia" role="tabpanel">
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">Cuenta bancaria</label>
                <select [(ngModel)]="transferenciaBancaria.account" class="form-select">
                  <option [ngValue]="''">Seleccione una cuenta</option>
                  <option *ngFor="let c of cuentasBanco" [ngValue]="c.CuentaContable">{{ c.NombreCuentaContable }}</option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label">Fecha de transferencia</label>
                <input [(ngModel)]="transferenciaBancaria.date" type="date" class="form-control">
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">Referencia</label>
                <input [(ngModel)]="transferenciaBancaria.reference" type="text" class="form-control">
              </div>
              <div class="mb-3">
                <label class="form-label">Total</label>
                <input [(ngModel)]="transferenciaBancaria.ammount" type="number" class="form-control" placeholder="0">
              </div>
            </div>
          </div>
          <!-- Posición del formulario principal (visible solo cuando hay cuenta seleccionada) -->
          <div class="row" *ngIf="transferenciaBancaria.account && transferenciaBancaria.account !== ''">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">Posición del formulario principal</label>
                <select [(ngModel)]="transferenciaBancaria.cashFlowLineItemID" class="form-select">
                  <option *ngFor="let p of posicionesFormulario" [ngValue]="p.CFWId">{{ p.CFWName }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <!-- Tarjeta -->
        <div class="tab-pane fade" id="tarjeta" role="tabpanel">

          <!-- Botón de intercambio de modo -->
          <div class="d-flex justify-content-end mb-3" *ngIf="transbankActivo && terminalesTransbank.length > 0">
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="toggleModoCobro()">
              <i class="fas fa-exchange-alt me-1"></i>
              {{ modoCobroTarjeta === 'automatico' ? 'Ingresar pago manual' : 'Volver a cobrar con Smart POS' }}
            </button>
          </div>

          <!-- ── VISTA MANUAL (Clásica) ─────────────────────────────── -->
          <div class="row" *ngIf="!transbankActivo || modoCobroTarjeta === 'manual'">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">Tipo de pago</label>
                <select [(ngModel)]="nuevaTarjetaCredito.paymentMethod" (change)="onPaymentMethodChange()" class="form-select">
                  <option [ngValue]="''">Seleccionar crédito o débito</option>
                  <option [ngValue]="'1'">TARJETA CRÉDITO (1)</option>
                  <option [ngValue]="'2'">TARJETA DÉBITO (2)</option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label d-flex justify-content-between align-items-center">
                  <span>Cuenta de mayor</span>
                  <small class="text-muted ms-2">{{ tarjetaCuentaName }}</small>
                </label>
                <div class="input-group input-group-sm">
                  <input [ngModel]="tarjetaCuentaLabel" class="form-control" readonly>
                  <button type="button" class="btn btn-warning"><i class="fas fa-arrow-right"></i></button>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label">Número tarjeta</label>
                <input [(ngModel)]="nuevaTarjetaCredito.creditCardNumber" [disabled]="!nuevaTarjetaCredito.paymentMethod" type="text" class="form-control">
              </div>
              <div class="mb-3">
                <label class="form-label">Válido hasta</label>
                <input [ngModel]="nuevaTarjetaCredito.validUntil" type="date" class="form-control" [disabled]="!nuevaTarjetaCredito.paymentMethod">
              </div>
              <div class="mb-3">
                <label class="form-label">Numero de ID</label>
                <input [(ngModel)]="nuevaTarjetaCredito.ownerIDNumber" [disabled]="!nuevaTarjetaCredito.paymentMethod" type="text" class="form-control">
              </div>
              <div class="mb-3">
                <label class="form-label">Numero de teléfono</label>
                <input [(ngModel)]="nuevaTarjetaCredito.ownerPhone" [disabled]="!nuevaTarjetaCredito.paymentMethod" type="tel" class="form-control">
              </div>
              <div class="mb-3">
                <label class="form-label">Tipo de transacción</label>
                <select [(ngModel)]="nuevaTarjetaCredito.transactionType" class="form-select" [disabled]="!nuevaTarjetaCredito.paymentMethod">
                  <option [ngValue]="'S'">Regular (S)</option>
                  <option [ngValue]="'U'">Telefónica (U)</option>
                  <option [ngValue]="'I'">Internet (I)</option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label">Total a pagar</label>
                <input [(ngModel)]="nuevaTarjetaCredito.ammountDue" (change)="onChangeTarjetaCalculos()" [disabled]="!nuevaTarjetaCredito.paymentMethod" type="number" class="form-control" placeholder="0">
              </div>
              <div class="mb-3">
                <label class="form-label">Cantidad de pagos</label>
                <input [(ngModel)]="nuevaTarjetaCredito.numerOfPayment" (change)="onChangeTarjetaCalculos()" [disabled]="!nuevaTarjetaCredito.paymentMethod" type="number" class="form-control" min="1" placeholder="1">
              </div>
              <div class="mb-3">
                <label class="form-label">Primer pago parcial</label>
                <input [(ngModel)]="nuevaTarjetaCredito.firsAmmountPayment" [disabled]="!nuevaTarjetaCredito.paymentMethod" type="number" class="form-control" placeholder="0">
              </div>
              <div class="mb-3">
                <label class="form-label">Cada pago adicional</label>
                <input [(ngModel)]="nuevaTarjetaCredito.eadAddAmmountPayment" [disabled]="!nuevaTarjetaCredito.paymentMethod" type="number" class="form-control" placeholder="0">
              </div>
              <div class="mb-3">
                <label class="form-label">N° Voucher</label>
                <input [(ngModel)]="nuevaTarjetaCredito.voucherNumebr" [disabled]="!nuevaTarjetaCredito.paymentMethod" type="number" class="form-control" placeholder="Número de voucher">
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">Tarjeta (OCRC)</label>
                <select [(ngModel)]="nuevaTarjetaCredito.creditCard" class="form-select" [disabled]="!nuevaTarjetaCredito.paymentMethod">
                  <option [ngValue]="0">Seleccionar tarjeta</option>
                  <option [ngValue]="1">VISA (1)</option>
                  <option [ngValue]="2">MASTERCARD (2)</option>
                </select>
              </div>
              <div class="mb-3">
                <button type="button" class="btn btn-sm w-100" 
                        [ngClass]="tarjetaEditIndex !== null ? 'btn-warning' : 'btn-outline-primary'" 
                        (click)="agregarTarjetaDesdeUI()" 
                        [disabled]="!nuevaTarjetaCredito.paymentMethod">
                  {{ tarjetaEditIndex !== null ? 'Actualizar Tarjeta' : 'Nuevo' }}
                </button>
              </div>

              <!-- Tabla modo manual -->
              <div *ngIf="tarjetaCredito && tarjetaCredito.length" class="table-responsive mt-3">
                <table class="table table-sm table-bordered table-hover mb-0">
                  <thead class="table-light">
                    <tr><th style="width:56px">N°</th><th>TARJETAS</th><th>MONTO</th><th style="width:40px"></th></tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let t of tarjetaCredito; let i = index"
                        (click)="cargarTarjetaParaEdicion(i)"
                        style="cursor: pointer;"
                        [class.table-active]="tarjetaEditIndex === i">
                      <td>{{t.Number}}</td>
                      <td>{{ t.paymentMethod === '1' ? 'TARJETA CRÉDITO' : 'TARJETA DÉBITO' }}</td>
                      <td class="text-end fw-bold text-success">$ {{ formatearMonto(t.ammountDue) }}</td>
                      <td><button class="btn btn-outline-danger btn-sm" (click)="eliminarTarjeta(i); $event.stopPropagation()"><i class="fas fa-trash"></i></button></td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div> <!-- End col-md-6 right -->
          </div> <!-- End row Manual -->

          <!-- ── VISTA SMART POS (Automática) ─────────────────────── -->
          <div *ngIf="transbankActivo && modoCobroTarjeta === 'automatico'">

            <!-- Resumen de Saldos del Documento -->
            <div class="d-flex justify-content-between align-items-center p-2 mb-3 bg-light rounded border">
              <div>
                <small class="text-muted d-block">Total Documento:</small>
                <strong class="text-dark fs-6">$ {{ formatearMonto(docTotal) }}</strong>
              </div>
              <div class="text-center">
                <small class="text-muted d-block">Total Pagado:</small>
                <strong class="text-success fs-6">$ {{ formatearMonto(totalPagado) }}</strong>
              </div>
              <div class="text-end">
                <small class="text-muted d-block">Saldo Pendiente:</small>
                <strong class="fs-6" [ngClass]="saldoPendiente > 0 ? 'text-danger' : 'text-success'">
                  $ {{ formatearMonto(saldoPendiente) }}
                </strong>
              </div>
            </div>

            <!-- Salvaguarda Anti-Pánico: Cobro previo detectado en POS sin asociar -->
            <div *ngIf="cobroRescateDisponible && !tarjetaYaCargada(cobroRescateDisponible)" class="alert alert-warning border border-warning shadow-sm p-3 mb-3" style="background-color: #fff9e6;">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <div class="fw-bold text-dark mb-1">
                    <i class="fas fa-shield-alt text-warning me-1"></i> Cobro previo en POS detectado (Hace {{ minutosAtras(cobroRescateDisponible.timestamp) }} min)
                  </div>
                  <div class="text-muted small">
                    Monto: <strong class="text-success">$ {{ formatearMonto(cobroRescateDisponible.totalPayment) }}</strong> — 
                    Voucher: <strong>#{{ cobroRescateDisponible.authorizationCode }}</strong> — 
                    {{ cobroRescateDisponible.cardType }} ****{{ cobroRescateDisponible.last4Digits }}
                    <span *ngIf="cobroRescateDisponible.terminalNombre"> ({{ cobroRescateDisponible.terminalNombre }})</span>
                  </div>
                </div>
                <div class="d-flex" style="gap: 6px;">
                  <button type="button" class="btn btn-sm btn-primary fw-bold" (click)="aplicarCobroRescate()">
                    <i class="fas fa-link me-1"></i> Cargar este pago
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-secondary" (click)="descartarCobroRescate()" title="Descartar si ya fue utilizado o anulado">
                    Descartar
                  </button>
                </div>
              </div>
            </div>

            <div class="card bg-dark border border-secondary shadow-lg mb-3">
              <div class="card-header py-2 d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <i class="fas fa-cash-register me-2 text-warning fa-lg"></i>
                  <h6 class="fw-bold mb-0 text-white">Cobro Directo en Smart POS</h6>
                </div>
                <span class="badge bg-primary">Transbank Cloud</span>
              </div>
              <div class="card-body p-3">

                <!-- 1. Selector de terminal (Arriba del monto) -->
                <div class="mb-3">
                  <label class="form-label text-light small fw-bold mb-1">
                    <i class="fas fa-terminal me-1 text-warning"></i> 1. Terminal de Pago:
                  </label>
                  <select class="form-select w-100" [(ngModel)]="terminalSeleccionadoId" (change)="onTerminalChange()"
                          [disabled]="tbkEstado === 'esperando' || tbkEstado === 'enviando'">
                    <option value="">— Seleccionar terminal —</option>
                    <option *ngFor="let t of terminalesTransbank" [value]="t._id">
                      {{ t.nombre }} — {{ t.sucursal }} ({{ t.ambiente }})
                    </option>
                  </select>
                </div>

                <!-- 2. Monto a cobrar (Abajo de la terminal) -->
                <div class="mb-3">
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <label class="form-label text-light small fw-bold mb-0">
                      <i class="fas fa-dollar-sign me-1 text-success"></i> 2. Monto a Cobrar:
                    </label>
                    <button *ngIf="saldoPendiente > 0" type="button"
                            class="btn btn-link btn-xs text-info p-0 text-decoration-none"
                            (click)="nuevaTarjetaCredito.ammountDue = saldoPendiente"
                            [disabled]="tbkEstado === 'esperando' || tbkEstado === 'enviando'">
                      Usar saldo pendiente ($ {{ formatearMonto(saldoPendiente) }})
                    </button>
                  </div>
                  <div class="input-group input-group-lg">
                    <span class="input-group-text fw-bold text-dark bg-light">$</span>
                    <input [ngModel]="montoFormateado" (ngModelChange)="onMontoChange($event)" type="text"
                           class="form-control text-end fw-bold fs-3" placeholder="0"
                           [disabled]="tbkEstado === 'esperando' || tbkEstado === 'enviando'">
                  </div>
                  <small class="text-muted mt-1 d-block">
                    <i class="fas fa-info-circle me-1"></i>
                    El tipo de pago (Débito/Crédito) y la marca de tarjeta se detectan automáticamente desde el POS.
                  </small>
                </div>

                <!-- 3. Botón de cobro y Barra de Espera / Cancelación -->
                
                <!-- Modo Normal: Botón verde para iniciar cobro -->
                <button *ngIf="tbkEstado !== 'enviando' && tbkEstado !== 'esperando'"
                        type="button" class="btn btn-success btn-lg w-100 mb-3 fw-bold shadow-sm py-3 fs-5"
                        (click)="cobrarEnTransbank()"
                        [disabled]="!nuevaTarjetaCredito.ammountDue || !terminalSeleccionadoId">
                  <i class="fas fa-credit-card me-2"></i>
                  Cobrar $ {{ montoFormateado || '0' }} en Smart POS
                </button>

                <!-- Modo Cobrando: Barra de Espera (80%) + Botón Cancelar Rojo (20%) -->
                <div *ngIf="tbkEstado === 'enviando' || tbkEstado === 'esperando'" class="d-flex gap-2 mb-3 align-items-stretch">
                  <div class="flex-grow-1 p-3 rounded d-flex align-items-center bg-primary text-white shadow border border-primary-subtle">
                    <div class="spinner-border text-warning me-3" style="width: 1.8rem; height: 1.8rem;"></div>
                    <div>
                      <div class="fw-bold fs-6">{{ tbkMensaje || 'Esperando que el cliente pase la tarjeta en el POS...' }}</div>
                      <small class="text-light opacity-75">Siga las instrucciones en la pantalla de la maquinita física</small>
                    </div>
                  </div>
                  <button type="button" class="btn btn-danger fw-bold shadow px-4 d-flex flex-column align-items-center justify-content-center"
                          style="min-width: 130px;"
                          (click)="cancelarTransbank()">
                    <i class="fas fa-times-circle fa-lg mb-1"></i>
                    <span>Cancelar</span>
                  </button>
                </div>

                <!-- Banner de Éxito (Aprobado) -->
                <div *ngIf="tbkEstado === 'aprobado'" class="p-3 rounded mb-3 bg-success text-white shadow border border-success">
                  <div class="d-flex align-items-center">
                    <i class="fas fa-check-circle fa-2x me-3 text-white"></i>
                    <div>
                      <h6 class="fw-bold mb-0 fs-5 text-white">¡Pago Aprobado con Éxito!</h6>
                      <div class="text-white fw-semibold">{{ tbkMensaje }}</div>
                    </div>
                  </div>
                </div>

                <!-- Banner de Error / Rechazo / Timeout (Alto Contraste y Legibilidad) -->
                <div *ngIf="tbkEstado === 'rechazado' || tbkEstado === 'cancelado'" class="p-3 rounded mb-3 bg-danger text-white shadow border border-danger">
                  <div class="d-flex align-items-start mb-2">
                    <i class="fas fa-exclamation-triangle fa-2x me-3 text-warning mt-1"></i>
                    <div class="flex-grow-1">
                      <h6 class="fw-bold mb-1 fs-5 text-white">
                        {{ tbkEstado === 'cancelado' ? 'Operación Cancelada' : 'Transacción Rechazada / Error en POS' }}
                      </h6>
                      <div class="text-white fw-bold fs-6">{{ tbkMensaje }}</div>
                    </div>
                  </div>
                  <!-- Caja de ID de Rastreo de Alto Contraste para Soporte / Fotos -->
                  <div class="p-2 rounded bg-black border border-light d-flex justify-content-between align-items-center mt-2">
                    <span class="text-warning fw-bold small"><i class="fas fa-id-badge me-1"></i> ID de Rastreo para Soporte:</span>
                    <span class="badge bg-warning text-dark font-monospace fs-6 px-2 py-1 fw-bold">
                      {{ tbkTraceId || tbkReferencia || 'N/A' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tabla de Tarjetas / Pagos Registrados -->
            <div *ngIf="tarjetaCredito && tarjetaCredito.length" class="table-responsive w-100 mt-3">
              <h6 class="text-light small fw-bold mb-2">
                <i class="fas fa-check-circle me-1 text-success"></i> Pagos con Tarjeta Confirmados:
              </h6>
              <table class="table table-sm table-dark table-striped table-bordered mb-0 align-middle small">
                <thead class="table-secondary text-dark">
                  <tr>
                    <th style="width:30px" class="text-center">#</th>
                    <th>Método</th>
                    <th>Últimos 4</th>
                    <th>Voucher</th>
                    <th>Cuotas</th>
                    <th class="text-end">Monto</th>
                    <th style="width:40px" class="text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let t of tarjetaCredito; let i = index">
                    <td class="text-center">{{ t.Number }}</td>
                    <td>
                      <span class="badge" [ngClass]="t.paymentMethod === '2' ? 'bg-info text-dark' : 'bg-primary'">
                        {{ t.paymentMethod === '2' ? '💳 DÉBITO' : '💳 CRÉDITO' }}
                      </span>
                    </td>
                    <td>
                      <span *ngIf="t.creditCardNumber">****{{ t.creditCardNumber }}</span>
                      <span *ngIf="!t.creditCardNumber" class="text-muted">—</span>
                    </td>
                    <td><code>{{ t.voucherNumebr || 'N/A' }}</code></td>
                    <td>{{ t.numerOfPayment > 1 ? t.numerOfPayment + ' cuotas' : 'Sin cuotas' }}</td>
                    <td class="text-end fw-bold text-success">$ {{ formatearMonto(t.ammountDue) }}</td>
                    <td class="text-center">
                      <button class="btn btn-outline-danger btn-xs" (click)="eliminarTarjeta(i)" title="Eliminar">
                        <i class="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
          <!-- ── FIN VISTA SMART POS ────────────────────────────────── -->
        </div>
        <!-- Efectivo -->
        <div class="tab-pane fade" id="efectivo" role="tabpanel">
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label d-flex justify-content-between align-items-center">
                  <span>Cuenta de mayor</span>
                  <small class="text-muted ms-2">{{ efectivoCuentaName }}</small>
                </label>
                <div class="input-group input-group-sm">
                  <input [ngModel]="efectivoCuentaLabel" class="form-control" readonly>
                  <button type="button" class="btn btn-warning"><i class="fas fa-arrow-right"></i></button>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label">Monto</label>
                <input [(ngModel)]="efectivo.ammount" type="number" class="form-control" placeholder="0">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end gap-2 mt-3">
        <button type="button" class="btn btn-secondary" (click)="cancelar()">Cancelar</button>
        <button type="button" class="btn btn-success" (click)="confirmar()">
          <i class="fas fa-paper-plane me-1"></i>Guardar pago
        </button>
      </div>
    </div>
  </div>
</div>
